import React, { useState } from 'react';
import './TabMenu.css';

/**
 * 재사용 가능한 탭 메뉴 컴포넌트
 *
 * @param {Array} tabs - 탭 목록 배열 [{ id: string, label: string, content: ReactNode }]
 * @param {string} defaultTab - 기본 선택될 탭 ID (선택사항)
 * @param {string} orientation - 탭 방향 'vertical' | 'horizontal' (기본값: 'vertical')
 * @param {Function} onTabChange - 탭 변경 시 콜백 함수 (선택사항)
 *
 * @example
 * <TabMenu
 *   tabs={[
 *     { id: 'company', label: '회사 관리', content: <CompanyManagement /> },
 *     { id: 'data', label: '데이터 확인', content: <DataVerification /> }
 *   ]}
 *   defaultTab="company"
 *   orientation="vertical"
 *   onTabChange={(tabId) => console.log('Selected tab:', tabId)}
 * />
 */
function TabMenu({ tabs, defaultTab, orientation = 'vertical', onTabChange }) {
  const [activeTab, setActiveTab] = useState(defaultTab || tabs[0]?.id);

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    if (onTabChange) {
      onTabChange(tabId);
    }
  };

  const activeTabContent = tabs.find(tab => tab.id === activeTab)?.content;

  return (
    <div className={`tab-menu-container tab-menu-${orientation}`}>
      {/* 탭 메뉴 */}
      <div className="tab-menu-list">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`tab-menu-item ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => handleTabClick(tab.id)}
            disabled={tab.disabled}
          >
            {tab.icon && (
              <span className="material-symbols-outlined tab-menu-icon">
                {tab.icon}
              </span>
            )}
            <span className="tab-menu-label">{tab.label}</span>
            {activeTab === tab.id && (
              <div className="tab-menu-indicator"></div>
            )}
          </button>
        ))}
      </div>

      {/* 탭 컨텐츠 */}
      <div className="tab-menu-content">
        {activeTabContent}
      </div>
    </div>
  );
}

export default TabMenu;
